import { __decorate, __metadata } from "tslib";
import { Component, Input } from 'angular-ts-decorators';
import { BottomMessageToken } from '../enums/bottom-message-token.enum';
import template from './faq-bottom-message.component.html';
var FaqBottomMessageComponent = (function () {
    function FaqBottomMessageComponent() {
        this.limit = 0;
    }
    Object.defineProperty(FaqBottomMessageComponent.prototype, "hasFaqItems", {
        get: function () {
            return Array.isArray(this.faqItems) && this.faqItems.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    FaqBottomMessageComponent.prototype.bottomMessage = function () {
        if (!Array.isArray(this.faqItems)) {
            return '';
        }
        var count = this.faqItems.length;
        var limit = this.limit > count ? count : this.limit;
        return (this.messageTemplate || '')
            .replace(BottomMessageToken.Limit, String(limit))
            .replace(BottomMessageToken.Number, String(count));
    };
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], FaqBottomMessageComponent.prototype, "messageTemplate", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], FaqBottomMessageComponent.prototype, "faqItems", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], FaqBottomMessageComponent.prototype, "limit", void 0);
    FaqBottomMessageComponent = __decorate([
        Component({
            selector: 'faqBottomMessage',
            template: template,
        })
    ], FaqBottomMessageComponent);
    return FaqBottomMessageComponent;
}());
export { FaqBottomMessageComponent };
